import { isUndefined } from 'util';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import template from './estimatedQuote.vue';

@Component({
    mixins: [template],
    components: {},
})
export default class EstimatedQuoteUnis100 extends Vue {
    quoteData = this.$store.getters.quoteData;

    isEditMode: boolean = false;
    isScheduleMode: boolean = false;
    isShowButtons: boolean = true;

    created() {
        let query = this.$route.query;

        this.isEditMode = query.isEdit ? true : false;
        this.isScheduleMode = query.schedule ? true : false;
        if (!isUndefined(query.isShowButtons)) {
            this.isShowButtons = query.isShowButtons === 'false' ? false : true;
        }
    }

    schedulePickup() {
        this.$emit('schedulePickup');
    }

    saveQuote() {
        this.$emit('saveQuote');
    }

    goToSavedQuotesPage() {
        this.$emit('goToSavedQuotesPage');
    }

    editQuote() {
        this.$emit('goEdit');
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/estimatedQuoteUnis100/index.ts